module.exports = __webpack_public_path__ + "img/groupe_santerre.34005bdd.png";